import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as actionTypes from './constants';

export const isLoading = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_WIP_CODES_FAILURE,
      actionTypes.FETCH_WIP_CODES_SUCCESS,
      actionTypes.FETCH_WIP_CODE_FAILURE,
      actionTypes.FETCH_WIP_CODE_SUCCESS,
      actionTypes.ADD_WIP_CODE_FAILURE,
      actionTypes.ADD_WIP_CODE_SUCCESS,
      actionTypes.UPDATE_WIP_CODE_FAILURE,
      actionTypes.UPDATE_WIP_CODE_SUCCESS,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_WIP_CODES_REQUEST,
      actionTypes.FETCH_WIP_CODE_REQUEST,
      actionTypes.ADD_WIP_CODE_REQUEST,
      actionTypes.UPDATE_WIP_CODE_REQUEST,
    )]: () => true,
  },
  false,
);

export const wipCodes = handleActions(
  {
    [actionTypes.FETCH_WIP_CODES_SUCCESS]: (state, { payload }) => payload,
    [actionTypes.UPDATE_WIP_CODE_SUCCESS]: (state, { payload }) =>
      state?.map((item) => {
        if (item.scope === payload.scope) {
          return {
            ...item,
            wipCodes: item.wipCodes?.map((wipCode) => {
              if (wipCode.id === payload.id) {
                return {
                  ...wipCode,
                  action: payload?.action,
                  code: payload?.code,
                  description: payload?.description,
                };
              }
              return wipCode;
            }),
          };
        }
        return item;
      }),
    [actionTypes.ADD_WIP_CODE_SUCCESS]: (state, { payload }) =>
      state?.map((item) => {
        if (item.scope === payload?.scope) {
          return {
            ...item,
            wipCodes: [
              ...item.wipCodes,
              {
                id: payload?.id,
                code: payload?.code,
                description: payload?.description,
                action: payload?.action,
              },
            ],
          };
        }
        return item;
      }),
    [actionTypes.DELETE_WIP_CODE_SUCCESS]: (state, { payload }) =>
      state?.map((item) => {
        if (item.scope === payload?.scope) {
          return {
            ...item,
            wipCodes: item?.wipCodes?.filter(wipCode => wipCode.id !== payload?.id),
          };
        }
        return item;
      }),
    [combineActions(
      actionTypes.FETCH_WIP_CODES_REQUEST,
      actionTypes.FETCH_WIP_CODES_FAILURE,
    )]: () => [],
  },
  [],
);

export const wipCodesForScope = handleActions(
  {
    [actionTypes.FETCH_WIP_CODES_SCOPE_SUCCESS]: (state, { payload }) => payload,
    [combineActions(
      actionTypes.FETCH_WIP_CODES_SCOPE_REQUEST,
      actionTypes.FETCH_WIP_CODES_SCOPE_FAILURE,
    )]: () => [],
  },
  [],
);

export const wipCode = handleActions(
  {
    [actionTypes.FETCH_WIP_CODE_SUCCESS]: (state, { payload }) => payload,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_WIP_CODE_REQUEST,
      actionTypes.FETCH_WIP_CODE_FAILURE,
    )]: () => ({}),
  },
  {},
);

export const wipCodesFromOrder = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_WIP_CODES_ORDER_SUCCESS,
      actionTypes.SAVE_WIP_CODES_ORDER_SUCCESS,
    )]: (state, { payload }) => payload,
    [combineActions(
      actionTypes.FETCH_WIP_CODES_ORDER_REQUEST,
      actionTypes.FETCH_WIP_CODES_ORDER_FAILURE,
    )]: () => [],
  },
  [],
);

export const wipCodeError = handleActions(
  {
    [combineActions(
      actionTypes.ADD_WIP_CODE_SUCCESS,
      actionTypes.ADD_WIP_CODE_REQUEST,
      actionTypes.UPDATE_WIP_CODE_SUCCESS,
      actionTypes.UPDATE_WIP_CODE_REQUEST,
    )]: () => ({}),
    [combineActions(
      actionTypes.ADD_WIP_CODE_FAILURE,
      actionTypes.UPDATE_WIP_CODE_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  isLoading,
  wipCodes,
  wipCodesForScope,
  wipCode,
  wipCodesFromOrder,
  wipCodeError,
});
